import { AgentAvatar } from '@/entities/agent';
import type { ImageUrlAvatar, AssetIdAvatar } from '@inference.engine/api-client/web';
import { getAgentMetadataHelpers } from '@/entities/agent';
import { CategoryId } from '@/shared/constants/category-colors.ts';

export const AgentHeader = ({
  agent,
}: {
  agent: {
    id: string;
    title: string;
    avatar?: ImageUrlAvatar | AssetIdAvatar;
    description?: string;
    tag?: CategoryId;
    isAccessDenied?: boolean;
  };
}) => {
  return (
    <div className="flex items-center gap-2 mb-3" data-testid="agent-header">
      <span className={agent.isAccessDenied ? 'grayscale' : undefined}>
        <AgentAvatar
          agentId={agent.id}
          agentTitle={agent.title}
          avatar={agent.avatar}
          tag={agent.tag}
        />
      </span>
      <div className="flex flex-col gap-1">
        <p className="text-sm font-medium leading-5 text-foreground">{agent.title}</p>
        {agent.description && getAgentMetadataHelpers().getAgentShowDescription(agent.id) && (
          <p className="text-xs leading-4 text-muted-foreground">{agent.description}</p>
        )}
      </div>
    </div>
  );
};
